import * as Common from "../../commons/common"

export class SheetListCondition{
  sheet_id: string = ""
  sheet_code: string = ""
  nendo: number = null
  report_no: number = null
  course_code: string = null
  campus_code: string = null
  class_code: string = null
  subject_code: string = null
  submitted_at: string = ""
  saiten_flg: string = ""
  sheet_type: number | string = ""
  page: number = 1
  row_count: number =  Common.SheetListRowCount
}

export class Sheet{
  id: number
  sheet_code: string
  sheet_type: number
  nendo: number
  sheet_name: string
  course_name: string
  campus_name: string
  class_name: string
  subject_name: string
  course_code: string
  campus_code: string
  class_code: string
  subject_code: string
  student_count: number
  mi_saiten_count: number
  submitted_at: string
  field_positions_completed: boolean
  cut_job_count: number
  full_count: number
  saiten_flg: boolean

  constructor(sheet: any){
    this.id = sheet.id;
    this.sheet_code = sheet.sheet_code;
    this.sheet_type = sheet.sheet_type;
    this.nendo = sheet.nendo;
    this.sheet_name = sheet.sheet_name;
    this.course_name = sheet.course_name;
    this.campus_name = sheet.campus_name;
    this.class_name = sheet.class_name;
    this.subject_name = sheet.subject_name;
    this.course_code = sheet.course_code;
    this.campus_code = sheet.campus_code;
    this.class_code = sheet.class_code;
    this.subject_code = sheet.subject_code;
    this.student_count = sheet.student_count;
    this.mi_saiten_count = sheet.mi_saiten_count;
    this.submitted_at = sheet.submitted_at;
    this.field_positions_completed = sheet.field_positions_completed;
    this.cut_job_count = sheet.cut_job_count;
    this.full_count = sheet.full_count;
    this.saiten_flg = sheet.saiten_flg;
  }
}
